import type { IChatStoreState } from './Chat.store';

export const chatSelectorsSupabase = {
    getAuth: (state: IChatStoreState) => ({
        selfProfile: state.selfProfile,
        isLoggedIn: state.isLoggedIn,
        isLoading: state.isLoading,
        error: state.error,
        hasMessages: !!state.messages.length,
    }),
    getHistory: (state: IChatStoreState) => ({
        messages: state.messages,
        selfProfile: state.selfProfile,
    }),
    getIsReady: (state: IChatStoreState) => ({
        isReady: state.isReady,
        isLoggedIn: state.isLoggedIn,
    }),
};
